import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ConfigurationService } from '../../../../core/_infrastructure/classes/services/configuration.service';
import { ProgramaVerificacionItemResultsViewModel, ProgramaVerificacionItemViewModel } from '../buscador-pvcam.types';

@Component({
    selector: 'app-buscador-pvcam-list',
    templateUrl: './buscador-pvcam-list.component.html',
})
export class BuscadorPvCamListComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() result: ProgramaVerificacionItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() edit = new EventEmitter<number | null>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    constructor(
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        protected configurationService: ConfigurationService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const pvCamVM = proxiedPropertiesOf<ProgramaVerificacionItemViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Image', header: '' },
            { field: pvCamVM.IdProgramaVerificacion?.toString(), header: 'IdProgramaVerificacion', display: 'none' },
            { field: pvCamVM.Campania, header: 'Campaña' },
            { field: pvCamVM.Periodo, header: 'Periodo' },
            { field: pvCamVM.ComunidadAutonoma, header: 'Comunidad Autonóma' },
            { field: pvCamVM.EntidadAuditora, header: 'Entidad Auditora' },
            { field: pvCamVM.FechaPresentacion, header: 'Fecha Presentacion' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;
            setTimeout(() => {
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter.PageNumber * this.result.PageSize;
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        const pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField,
        };

        this.search.emit(f);
    }

    onEdit(item: ProgramaVerificacionItemViewModel): void {
        this.edit.emit(item?.IdProgramaVerificacion);
    }
}
